/** Presentation helpers. No API knowledge lives here. */

const DAY = 86_400_000;

/**
 * Dates in a mail list are read at a glance, so recent ones show a time and
 * older ones a date. A full timestamp on every row is noise nobody scans.
 */
export function listDate(timestamp: number): string {
	if (!timestamp) {
		return '';
	}

	const date = new Date(timestamp * 1000);
	const now = new Date();

	const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();

	if (date.getTime() >= startOfToday) {
		return date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
	}
	if (date.getTime() >= startOfToday - 6 * DAY) {
		return date.toLocaleDateString(undefined, { weekday: 'short' });
	}
	if (date.getFullYear() === now.getFullYear()) {
		return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
	}
	return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

/** Full timestamp for the reading pane, where precision is worth the space. */
export function fullDate(timestamp: number): string {
	if (!timestamp) {
		return '';
	}
	return new Date(timestamp * 1000).toLocaleString(undefined, {
		weekday: 'short',
		day: 'numeric',
		month: 'short',
		year: 'numeric',
		hour: 'numeric',
		minute: '2-digit'
	});
}

export function fileSize(bytes: number): string {
	if (!bytes) {
		return '';
	}
	const units = ['B', 'KB', 'MB', 'GB'];
	let value = bytes;
	let unit = 0;
	while (value >= 1024 && unit < units.length - 1) {
		value /= 1024;
		unit += 1;
	}
	return `${value < 10 && unit > 0 ? value.toFixed(1) : Math.round(value)} ${units[unit]}`;
}

/**
 * Folder names arrive as full IMAP paths ("INBOX/Receipts"). Only the leaf is
 * worth showing, and INBOX is titled rather than shouted.
 */
export function folderLabel(fullName: string, delimiter: string): string {
	const leaf = delimiter ? fullName.split(delimiter).pop() ?? fullName : fullName;
	return 'INBOX' === leaf.toUpperCase() ? 'Inbox' : leaf;
}
